import { CategoryRef, Filter } from '~/mappers/itemListing/models';

export const getActiveFiltersGroup = (filters: Filter[], activeGroup: string) =>
  filters.find(({ label }) => label === activeGroup);

export const isFilterActive = (
  filter: { group: string; value: CategoryRef }[],
  filterUid: string
) => filter.find(({ value: { uid } }) => uid === filterUid);
